// NOTE: サーバ側の GuardianMessage::MAX_OUTGOING_CONTENT_LENGTH に対応する。
// LINE へ送信する本文の上限。LINE が 1 通で送れる最大（5000）から、
// 送信時に付与される校舎名・生徒名などの差出人表示分の余白を引いた値。
// Line::KarteSharingEntity / Line::AnalyticsSharingEntity がこの値で検証する。
// カルテ本文そのものの上限は KarteContentMaxLength を参照すること。
// https://github.com/studyplus/boron/pull/6971
export const LineOutgoingMessageMaxLength = 4000;
